import React from 'react'
import { browserHistory } from 'react-router'
import { user } from '../../core/controllers/user';
import PropertyEdit from '../../components/Properties/PropertyEdit';
import PropertyOwnerEdit from '../../components/Properties/PropertyOwnerEdit'

export default class PropertyTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUpdate(nextProps, nextState) {

    }

    addLeases() {
        browserHistory.push('/leases');
    }

    render(){
        var newProp = true;
        if(this.props.propertyId.length > 0 && this.props.propertyId !== 'new'){
            newProp = false;
        }

        var isOwner = false;
        if (user.userInfo) {
            if (user.userInfo.user_type_alias == "owner") {
                isOwner = true
            }
        }

        return (
            <div>
                <div class="row">
                    <div class="col-md-1">
                        <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                    </div>
                </div>
                {isOwner == true ? (
                <PropertyOwnerEdit propertyId={this.props.propertyId} />
                ) : (
                <PropertyEdit propertyId={this.props.propertyId} newProp={newProp} />
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Property/Property.jsx